// extracted by mini-css-extract-plugin
export default {"label":"_5Ewkuh6XzpIu2S3BSpetAT","verticalAlignMiddle":"uGCjwKNU3CjE9O0vauvsS","labelText":"_44dQQcOBZEu9hGNoCz7P6I","icon":"_5tR5bPdXX15zti8NJ6XYCi"};